import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import CoverageTemplate, {
  CoverageType,
} from "../../components/coverage-template"

import {
  CoverageCommercialRealEstateMeta,
  CoverageLessorsRiskMeta,
  CoverageRetailMeta,
} from "../../data/seo-meta"

import {
  EnvironmentalBrochure,
  ExcessCasualtyBrochure,
  LessorsRiskBrochure,
} from "../../data/brochures"

import lessorsRiskIcon from "../../images/coverage/product/lessors-risk.svg"

const related = [
  {
    name: "Commercial Real Estate",
    href: CoverageCommercialRealEstateMeta.path,
  },
  { name: "Retail", href: CoverageRetailMeta.path },
]

const downloads = [
  { name: "Brochure - Lessor’s Risk", href: LessorsRiskBrochure },
  { name: "Brochure - Environmental", href: EnvironmentalBrochure },
  { name: "Brochure - Excess Casualty", href: ExcessCasualtyBrochure },
]

const CoverageLessorsRiskPage = () => (
  <Layout>
    <SEO
      description={CoverageLessorsRiskMeta.description}
      path={CoverageLessorsRiskMeta.path}
      title={CoverageLessorsRiskMeta.title}
    />
    <CoverageTemplate
      icon={lessorsRiskIcon}
      type={CoverageType.Product}
      title={CoverageLessorsRiskMeta.title}
      description={CoverageLessorsRiskMeta.description}
      related={related}
      downloads={downloads}
    >
      <h3 className="h3">TARGET RISKS:</h3>
      <ul>
        <li>
          Risks leasing commercial real estate for:
          <ol>
            <li>Banks and Financial Institutions</li>
            <li>Bars and Taverns</li>
            <li>Gas Stations</li>
            <li>Hotels and Motels</li>
            <li>Land</li>
            <li>Mixed-use Buildings, with Minimal Habitational Exposure</li>
            <li>New Ventures/ New Purchases</li>
            <li>Offices</li>
            <li>Restaurants</li>
            <li>Retail</li>
            <li>Service Occupancies</li>
            <li>Shopping Centers</li>
            <li>Warehouses</li>
            <li>And more</li>
          </ol>
        </li>
        <li>Premises maintained by the insured or tenant are eligible</li>
      </ul>

      <h3 className="h3">COVERAGES AVAILABLE:</h3>
      <ul>
        <li>Package or Monoline policies available</li>
        <li>$1M/ $2M General Liability limits</li>
        <li>First Dollar Coverage available</li>
        <li>Property can be written Monoline or as a Package</li>
        <li>
          Special form cause of loss for building, business personal property,
          business income and extra expense is available.
        </li>
        <li>
          PHLY Property Enhancement Endorsement
          <ol>
            <li>
              Including Accounts Receivable, Back Up of Sewers & Drains, Limited
              Crime Coverage, Property in Transit, Employee Dishonesty Pollutant
              clean-up etc.
            </li>
          </ol>
        </li>
      </ul>

      <h3 className="h3">SUBMISSION REQUIREMENTS:</h3>
      <ul>
        <li>Completed ACORD Applications</li>
        <li>Lessor’s Risk Supplemental</li>
        <li>
          Currently valued insurance company loss runs for the current policy
          period plus 4 prior years
        </li>
        <li>
          Confirmation that the owner collects Certificates of Insurance with
          additional insured status from all tenants
        </li>
      </ul>

      <h3 className="h3">ALSO AVAILABLE UNDER SEPARATE COVER:</h3>

      <h4 className="h4 -mb-4">Environmental</h4>
      <ul>
        <li>Premises Environmental Coverage (PEC)</li>
        <li>Minimum Premium - $3,000</li>
        <li>
          Maximum Capacity – $15M per occurrence/ $15M aggregate SIRs from
          $5,000/ $25,000
        </li>
      </ul>

      <h4 className="h4 -mb-4">Excess</h4>
      <ul>
        <li>Excess maximum capacity $5M</li>
        <li>Lead Umbrella and Excess placement</li>
        <li>Supported and unsupported capabilities</li>
      </ul>
    </CoverageTemplate>
  </Layout>
)

export default CoverageLessorsRiskPage
